
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Home, Truck, Recycle, Phone } from "lucide-react";

const Particuliers = () => {
  const services = [
    {
      title: "Location de bennes",
      description: "Bennes pour vos travaux de rénovation et jardinage",
      icon: Truck,
      link: "/nos-services/location-bennes"
    },
    {
      title: "Rachat de métaux",
      description: "Rachat de vos métaux au meilleur prix",
      icon: Recycle,
      link: "/nos-services/achat-metaux"
    },
    {
      title: "Débarras maison",
      description: "Service de débarras complet pour votre domicile",
      icon: Home,
      link: "/contact"
    },
    {
      title: "Conseil personnalisé",
      description: "Accompagnement dans vos projets de recyclage",
      icon: Phone,
      link: "/contact"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Services Particuliers - Groupe Fabre Environnement"
        description="Services de gestion des déchets pour particuliers : location de bennes, rachat de métaux, débarras. Solutions adaptées à vos besoins."
        canonical="/services/particuliers"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-green-600 to-green-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Services Particuliers</h1>
              <p className="text-xl opacity-90">
                Solutions simples et efficaces pour tous vos besoins 
                de gestion des déchets à domicile.
              </p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service, index) => {
                const IconComponent = service.icon;
                return (
                  <Link key={index} to={service.link} className="block group">
                    <div className="bg-gray-50 p-8 rounded-lg hover:shadow-lg transition-shadow">
                      <div className="w-16 h-16 bg-green-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                        <IconComponent className="h-8 w-8 text-white" />
                      </div>
                      <h3 className="text-2xl font-bold text-fabre-gray mb-4">{service.title}</h3>
                      <p className="text-gray-600 mb-4">{service.description}</p>
                      <div className="text-green-600 font-medium group-hover:underline">
                        En savoir plus →
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        {/* Info Section */}
        <section className="py-16 bg-green-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-3xl font-bold text-fabre-gray mb-6">
                Pourquoi choisir Groupe Fabre ?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div>
                  <h3 className="text-xl font-bold text-fabre-gray mb-4">Proximité</h3>
                  <p className="text-gray-600">Service local et réactif dans toute la région</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-fabre-gray mb-4">Expertise</h3>
                  <p className="text-gray-600">Plus de 25 ans d'expérience dans le recyclage</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-fabre-gray mb-4">Engagement</h3>
                  <p className="text-gray-600">Respect de l'environnement et développement durable</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Particuliers;
